export default function Page(props) {
	return (
		<div className="pb-6 -mt-6">
			<div className="p-4 sm:px-6 md:px-8">
				{props.children}
			</div>
		</div>
	)

}